import React from "react"
import { Box, Card, CardContent, Typography } from "@mui/material";
import dayjs from "dayjs";

export const customComponents = {
  eventModal: ({ calendarEvent, currentView }) => {
    const startDate = dayjs(calendarEvent?.[currentView === 'week' || currentView === 'day' ? 'displayStartDate' : 'start']?.toString()?.split('[')[0]);
    const endDate = dayjs(calendarEvent.realEndDate.toString().split('[')[0]);
    return (
      <Card
        elevation={2}
        sx={{
          borderLeft: '4px solid #038C7F',
        }}
      >
        <CardContent>
          <Typography variant="body2">
            <b>
              {calendarEvent.title}
            </b>
          </Typography>
          <Typography variant="body2">
            <b>
              {`${startDate.format('DD/MM/YYYY HH:mm')} - ${endDate.format('DD/MM/YYYY HH:mm')}`}
            </b>
          </Typography>
          <Typography variant="body2">
            <b>
              {'Turno: '}
            </b>
            {calendarEvent.workShiftName}
          </Typography>
          <Typography variant="body2">
            <b>
              {'Comandante: '}
            </b>
            {calendarEvent.commander}
          </Typography>
          {calendarEvent.driver &&
            <Typography variant="body2">
              <b>
                {'Motorista: '}
              </b>
              {calendarEvent.driver}
            </Typography>
          }
          {calendarEvent.patrolmans.length > 0 &&
            <Typography variant="body2">
              <b>
                {'Patrulheiros: '}
              </b>
              {calendarEvent.patrolmans.map((patrolman) => patrolman.representation_name).join(', ')}
            </Typography>
          }
        </CardContent>
      </Card>
    );
  },
//   monthGridEvent: ({ calendarEvent }) => { 
//     return (
//       <Box>
//         <Typography>
//       {calendarEvent.title}
//         </Typography>
//   </Box>
// )
//   },
  timeGridEvent: ({ calendarEvent , currentView }) => {
    const startDate = dayjs(calendarEvent?.[currentView === 'week' || currentView === 'day' ? 'displayStartDate' : 'start']?.toString()?.split('[')[0]);

    // Se for o último segmento ou evento único, mostra o realEndDate
    // Caso contrário, mostra o end (23:59)
    const displayEndDate = calendarEvent._isLastSegment || !calendarEvent.realEndDate
      ? dayjs(calendarEvent.end.toString().split('[')[0])
      : dayjs(calendarEvent.realEndDate.toString().split('[')[0]);

    return (
      <Box
        sx={{
          padding: '4px 8px',
          height: '100%',
          overflow: 'hidden',
          backgroundColor: '#038C7F',
          borderTop: '4px solid #00b2a0',
          borderLeft: '4px solid #00b2a0',
          borderRadius: '4px',
          color: 'white',
          // cursor: 'pointer',
          // '&:hover': {
          //   backgroundColor: '#025047',
          // }
        }}
      >
        <Typography
          variant="caption"
          sx={{
            fontWeight: 'bold',
            display: 'block',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis'
          }}
        >
          {calendarEvent.title}
        </Typography>
        <Typography
          variant="caption"
          sx={{
            display: 'block',
            fontSize: '0.7rem'
          }}
        >
          {`${startDate.format('DD/MM/YYYY HH:mm')} - ${displayEndDate.format('DD/MM/YYYY HH:mm')}`}
        </Typography>
      </Box>
    );
  },
}
